<template>
  <div class="mb-8">
    <h4 class="title-type-3">
      {{ propOption.name }}
      <v-tooltip right content-class="tooltip-custom-1">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="ml-2" v-bind="attrs" v-on="on"
            >mdi-alert-circle-outline</v-icon
          >
        </template>
        <span>{{ propOption.note }}</span>
      </v-tooltip>
    </h4>
    <div class="relative white rounded pa-6 pr-16">
      <div class="form-row-1 mb-8">
        <p class="label">홀 개수</p>
        <div class="write-con">
          <div class="d-flex">
            <p class="num-type-1" v-for="(hole, i) in holes" :key="i">
              <a
                href="javascript:void(0);"
                :class="{
                  active: hole.active,
                  ready: hole === selectedOptionItem,
                }"
                @click.prevent="selectHole(hole)"
              >
                {{ hole.client_key }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import _ from 'lodash';

export default {
  props: {
    propOption: Object,
    propLineItem: Object,
    selectedOptionItem: Object,
  },
  data: () => ({
    holes: null,
  }),
  methods: {
    setHoles() {
      const lris = this.propLineItem ? this.propLineItem.lris : [];
      const condition = this.propOption.condition;

      this.holes = this.propOption.items
        .filter(i =>
          condition ? condition.includes(parseInt(i.client_key)) : true,
        )
        .map(item => {
          const lri = lris.find(lri => lri.item_id === item.id);
          return { ...item, active: !!_.get(lri, 'resources.length') };
        })
        .sort((a, b) => a.client_key - b.client_key);
    },
    selectHole(hole) {
      if (this.selectedOptionItem === hole) return;

      bus.$emit('option_item:select', hole);
    },
  },
  watch: {
    propLineItem: {
      deep: true,
      handler() {
        this.setHoles();
      },
    },
    holes: {
      handler() {
        let clientKey, selectedHole;
        if (this.selectedOptionItem) {
          clientKey = this.selectedOptionItem.client_key;
        } else {
          const lri = this.propLineItem.lris.filter(r => r.resources.length)[0];
          clientKey = lri ? lri.client_key : this.holes[0].client_key;
        }
        selectedHole = this.holes.find(h => h.client_key === clientKey);

        this.selectHole(selectedHole);
      },
    },
  },
  created() {
    this.setHoles();
  },
};
</script>
